<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container
        :class="{
          'px-10': !mobile,
          'pt-8': !mobile,
          'pa-4': mobile
        }"
      >
        <p class="subtitle-1 font-weight-bold mb-2">New Group</p>
        <v-row>
          <v-col class="pb-0" cols="12" sm="12" md="12">
            <v-text-field
              v-model="groupName"
              label="Group Name"
              required
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- <v-row class="my-0">
          <v-col class="py-0" cols="12">
            <v-text-field
              v-model="newGroupTag"
              outlined
              dense
              label="Add new group tag"
              append-icon="mdi-plus"
              class="mt-2"
              hide-details
              @click:append="addGroupTag"
            >
            </v-text-field>
          </v-col>
        </v-row> -->
        <v-row class="ma-0 mt-2">
          <v-col class="pa-0" cols="12">
            <v-chip-group multiple column class="pt-0">
              <v-chip
                v-for="(tag, index) in tags"
                :key="index"
                outlined
                color="primary"
                class="mr-4"
                close
                @click:close="deleteGroupTag(tag)"
              >
                <div class="chip-label">
                  {{ tag }}
                </div>
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
        <v-card-actions :class="{ 'pa-0': mobile }">
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            text
            @click="finish"
            >Finish</v-btn
          >
          <v-btn
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click="cancel"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      groupName: '',
      parentAddressId: undefined,
      dialog: false,
      newGroupTag: null,
      tags: [],
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      }
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    open({ parentAddressId }) {
      this.parentAddressId = parentAddressId
      this.dialog = true
      //this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      try {
        this.$root.$setLoading(true)
        await this.$store.dispatch('units/newGroupAction', {
          groupName: this.groupName,
          parentAddressId: this.parentAddressId,
          tags: this.tags
        })
        this.tags = []
        this.dialog = false
        this.$root.$setLoading(false)
        this.resolve(true)
      } catch (err) {
        this.$root
          .$confirm({
            title: 'Create Group Error',
            message: err,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'error'
            }
          })
          .then(() => {
            this.loading = false
            this.$root.$setLoading(false)
            this.reject(false)
          })
      }
    },
    cancel() {
      this.dialog = false
      this.$root.$setLoading(false)
      this.resolve(false)
    },
    addGroupTag() {
      this.tags.push(this.newGroupTag)
      this.newGroupTag = null
    },
    deleteGroupTag(toRemove) {
      this.tags = this.tags.filter((tag) => tag != toRemove)
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
